export default __webpack_public_path__ + "static/media/pic3.bd104189.jpg";